import { KeyboardEvent } from 'react';

import { ReactSelectInstance, ReactSelectInstanceRefObject } from '@ui/select/react-select/custom-react-select.types';

type TArrowKeyProps = {
  select: ReactSelectInstance;
  openAt: 'first' | 'last';
  direction: 'up' | 'down';
};

const handleArrowKey = ({ select, openAt, direction }: TArrowKeyProps) => {
  if (!select) return;
  if (!select.props.menuIsOpen) {
    select.openMenu(openAt);
  }
  // get focused ref and if it has a nested button, focus the button
  // else, if it doesn't have a button or the button is already focused, then call focusOption('down')
  const focusedEl = select.focusedOptionRef;
  if (focusedEl && focusedEl instanceof HTMLDivElement) {
    const button = focusedEl.querySelector('button');
    if (button && button instanceof HTMLButtonElement) {
      if (!button.classList.contains('base-language-focused')) {
        button.classList.add('base-language-focused');
        button.setAttribute('data-base-focused', 'true');
        return;
      }
      button.setAttribute('data-base-focused', 'false');
      button.classList.remove('base-language-focused');
    }
  }
  select.focusOption(direction);
};

/**
 * Handles keyboard navigation for the language menu in the languages selector
 * to allow up/down arrow keys to cycle through options and the base selector button
 */
const handleLanguageMenuNavigating = (selectRef: ReactSelectInstanceRefObject) => (e: KeyboardEvent) => {
  const select = selectRef?.current;
  if (!select) return;
  if (e.key === 'Enter') {
    const focusedButton = select.focusedOptionRef?.querySelector('button[data-base-focused="true"]');
    if (focusedButton && focusedButton instanceof HTMLButtonElement) {
      e.preventDefault();
      focusedButton.click(); /* This will trigger the "BASE" button inside of `language-selector-option.tsx` */
      focusedButton.setAttribute('data-base-focused', 'false');
      focusedButton.classList.remove('base-language-focused');
      return;
    }
  }
  if (['ArrowDown', 'ArrowUp'].includes(e.key)) {
    e.preventDefault();
    if (e.key === 'ArrowDown') {
      handleArrowKey({
        select,
        openAt: 'first',
        direction: 'down',
      });
    }
    if (e.key === 'ArrowUp') {
      handleArrowKey({
        select,
        openAt: 'last',
        direction: 'up',
      });
    }
  }
};

export default handleLanguageMenuNavigating;
